import AMApp from '../../../../../../../src/global/app';
import Highcharts from 'highcharts/highstock';

export class FondsDetailConfig {
  isGerman = true;
  inputDateFormatHighCharts = '%d.%m.%Y';
  momentDateFormat = 'DD.MM.YYYY';
  rangeSelectorButtonsDE = [{
    type: 'month',
    count: 1,
    text: '1M',
    value: '1M'
  }, {
    type: 'month',
    count: 3,
    text: '3M',
    value: '3M'
  }, {
    type: 'month',
    count: 6,
    text: '6M',
    value: '6M'
  }, {
    type: 'year',
    count: 1,
    text: '1J',
    value: '1y'
  }, {
    type: 'year',
    count: 5,
    text: '5J',
    value: '5y'
  }, {
    type: 'year',
    count: 10,
    text: '10J',
    value: '10y'
  }];

  rangeSelectorButtonsEN = [{
    type: 'month',
    count: 1,
    text: '1M',
    value: '1M'
  }, {
    type: 'month',
    count: 3,
    text: '3M',
    value: '3M'
  }, {
    type: 'month',
    count: 6,
    text: '6M',
    value: '6M'
  }, {
    type: 'year',
    count: 1,
    text: '1Y',
    value: '1y'
  }, {
    type: 'year',
    count: 5,
    text: '5Y',
    value: '5y'
  }, {
    type: 'year',
    count: 10,
    text: '10Y',
    value: '10y'
  }];

  plotOptions = {
    area: {
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, '#80a8d4'],
          [1, '#f49a4b']
        ]
      },
      marker: {
        radius: 2
      },
      lineWidth: 1,
      states: {
        hover: {
          lineWidth: 1
        }
      },
      threshold: null
    },
  };

  chartDefs = {
    gradient0: {
      tagName: 'linearGradient',
      id: 'gradient-0',
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1,
      children: [{
        tagName: 'stop',
        offset: 0
      }, {
        tagName: 'stop',
        offset: 1
      }]
    },
  };

  icmaColors = {
    'benchmarkwechsel': '#003252',
    'fondsuebernahme': '#618fb5',
    'strategieanderung': '#81878c',
  };

  useHighChartsRangeSelector = true;

  datepickerEnabled = true;

  rangeSelector = {
    selected: 3,
    buttons: this.rangeSelectorButtonsDE,
    inputDateFormat: this.inputDateFormatHighCharts,
    inputEditDateFormat: this.inputDateFormatHighCharts,
    enabled: this.useHighChartsRangeSelector,
    buttonPosition: {
      x: 0,
      y: 0,
    },
    buttonTheme: {
      height: 24,
      width: 32,
      style: {
        color: '#ffffff',
        fontWeight: 'bold',
      },
      states: {
        select: {
          style: {
            color: '#ffffff',
          }
        },
        disabled: {
          opacity: 0.6,
        }
      },
    },
    inputPosition: {
      x: 0,
      y: 0,
    },
    inputBoxHeight: 24,
    inputStyle: {
      color: '#333333',
      fontWeight: 'bold'
    },
  }

  chartExporting = {
    buttons: {
      contextButton: {
        menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadPDF']
      }
    }
  }

  chartResponsive = {
    rules: [{
      condition: {
        maxWidth: 500
      },
      chartOptions: {
        chart: {
          height: 300
        },
        navigator: {
          enabled: true
        }
      }
    }]
  }

  scrollbar = {
    barBorderRadius: 0,
    barBorderWidth: 1,
    buttonsEnabled: true,
    height: 20,
    margin: 0,
    rifleColor: 'none',
    trackBackgroundColor: '#f2f2f2',
    trackBorderRadius: 0,
  };

  colors = {
    primaryBlue: '#123250',
    primaryGreen: '#37c391',
  };
}